import { useAuth } from '@/context/AuthContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { LeagueSettingsLayout } from '@/components/LeagueSettingsLayout';
import { CreditCard } from 'lucide-react';

export default function LeagueBilling() {
  const { currentMembership } = useAuth();

  if (!currentMembership) {
    return (
      <LeagueSettingsLayout activeTab="billing">
        <p className="text-stone-600">No league selected</p>
      </LeagueSettingsLayout>
    );
  }

  return (
    <LeagueSettingsLayout activeTab="billing">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <CreditCard className="h-5 w-5" />
            Billing
          </CardTitle>
          <CardDescription>Manage entry fees and payments</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-stone-500 text-center py-8">
            Coming soon — billing and payment features are under development.
          </p>
        </CardContent>
      </Card>
    </LeagueSettingsLayout>
  );
}
